<div class="mw-100" style="background-color: white; height: 100%;">
    <app-navbar></app-navbar>
    <div class="container">  
        <div class="p-card-header p-component p-card-header-primary">
            <h5 class="pdfs-15">{{ 'DETAILS' | translate}}</h5>
        </div>
        <div *ngIf="campaignDetails">
            <h5 class="details">{{ campaignDetails.nombreCampania }} - {{ campaignDetails.id }} ({{campaignDetails.estatusCampania}})</h5>
            <h5 class="details">{{ 'SHIPPING_PROGRESS_DETAIL' | translate}}</h5>
            <h5 *ngIf="successfulMessages.length > 0" class="details">{{ 'SUCCESSFULLY_SENT_DETAIL_1' | translate}} {{ totalExitos }} {{ 'MESSAGES_OF_DETAIL_1' | translate}} {{ totalProcesados }} {{ 'PROCESSED_DETAIL_1' | translate}}</h5>
            <h5 *ngIf="incorrectMessages.length > 0" class="details">{{ 'FOUND_DETAIL' | translate}} {{ totalErrores }} {{ 'FAILED_MESSAGES_OF_DETAIL' | translate}} {{ totalProcesados }} {{ 'PROCESSED_DETAIL_2' | translate}}</h5>
            <h5 *ngIf="successfulMessages.length > 0 && incorrectMessages.length > 0" class="details">{{ 'SUCCESSFULLY_SENT_DETAIL_2' | translate}} {{ totalExitos }} {{ 'MESSAGES_OF_DETAIL_2' | translate}} {{ totalProcesados }} {{ 'PROCESSED_DETAIL_3' | translate}}</h5>
            <h5 class="details">{{ 'START_DATE_DETAIL' | translate}} {{campaignDetails.fechaHoraInicio | date: 'dd/MM/YYYY, h:mm:ss'}}</h5>
            <h5 class="details">{{ 'END_DATE_DETAIL' | translate}} {{campaignDetails.fechaHoraFin | date: 'dd/MM/YYYY, h:mm:ss'}}</h5>
        </div>

        <div class="p-grid">
            <div class="p-col-6">
                <div>
                    <p-chart type="doughnut" [data]="chartData" [options]="chartOptions" width="400" height="400"></p-chart>
                </div>
            </div>
            <div class="p-col-6" style="overflow: hidden;">
                <div *ngIf="campaignDetails" style="width: 100%;">
                    <p-table [value]="successfulMessages" styleClass="p-datatable-gridlines" [tableStyle]="{ 'max-width': '50rem', 'margin-bottom': '20px' }">
                        <ng-template pTemplate="caption">
                            <div class="toggle-button">
                                <button class="p-button p-button-text" (click)="toggleTable()">
                                    <i class="pi pi-chevron-up" *ngIf="showTableContent"></i>
                                    <i class="pi pi-chevron-down" *ngIf="!showTableContent"></i>
                                </button>
                                {{ 'SUCCESSFUL_MESSAGES' | translate}} {{successfulMessages.length}}
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr *ngIf="showTableContent">
                                <th>{{ 'NUMBERS_DETAILS' | translate}}</th>
                                <th>{{ 'STATUS_DETAILS' | translate}}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-message of successfulMessages>
                            <tr *ngIf="showTableContent">
                                <td>{{ message.numero }}</td>
                                <td>{{ message.estatus }}</td>
                            </tr>
                        </ng-template>
                    </p-table>

                    <p-table [value]="noFindNumbers" styleClass="p-datatable-gridlines" [tableStyle]="{ 'max-width': '50rem', 'margin-bottom': '20px' }">
                        <ng-template pTemplate="caption">
                            <div class="toggle-button">
                                <button class="p-button p-button-text" (click)="toggleTable()">
                                    <i class="pi pi-chevron-up" *ngIf="showTableContent"></i>
                                    <i class="pi pi-chevron-down" *ngIf="!showTableContent"></i>
                                </button>
                                {{ 'NUMBERS_NOT_FOUND' | translate}} {{noFindNumbers.length}}
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr *ngIf="showTableContent">
                                <th>{{ 'NUMBERS_DETAILS' | translate}}</th>
                                <th>{{ 'STATUS_DETAILS' | translate}}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-message of noFindNumbers>
                            <tr *ngIf="showTableContent">
                            <td>{{ message.numero }}</td>
                            <td>{{ message.estatus }}</td>
                            </tr>
                        </ng-template>
                    </p-table>

                    <p-table [value]="incorrectMessages" styleClass="p-datatable-gridlines" [tableStyle]="{ 'max-width': '50rem', 'margin-bottom': '20px'}">
                        <ng-template pTemplate="caption">
                            <div class="toggle-button">
                                <button class="p-button p-button-text" (click)="toggleTable()">
                                    <i class="pi pi-chevron-up" *ngIf="showTableContent"></i>
                                    <i class="pi pi-chevron-down" *ngIf="!showTableContent"></i>
                                </button>
                                {{ 'FAILED_MESSAGES' | translate}} {{incorrectMessages.length}}
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr *ngIf="showTableContent">
                                <th>{{ 'NUMBERS_DETAILS' | translate}}</th>
                                <th>{{ 'STATUS_DETAILS' | translate}}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-message of incorrectMessages>
                            <tr *ngIf="showTableContent">
                            <td>{{ message.numero }}</td>
                            <td>{{ message.estatus }}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
        <div class="button">
            <button class="p-button p-component btn" (click)="regresar(deviceUrl, deviceName)">{{ 'BACK' | translate}}</button>
        </div> 
    </div>
</div>